/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin callMeNowManager/services/AmazonConnectService";

/**
 * Gets the Flows for the amazon connect instance from the connect lookups endpoint.
 */
export const getContactFlowsAsync = async () => {
	try {
		let flows = await axios.get(`${APIGateways.connectLookupsEndpoint}/contactFlows`, {
			headers: await getAuthHeader(),
		});

		return flows.data.ContactFlowSummaryList.sort((a, b) => a.Name.localeCompare(b.Name));
	} catch (error) {
		v2.error(`Error getting contact flows`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_CONTACT_FLOWS_API_ERROR,
		});
		throw error;
	}
};

/**
 * Gets the phone numbers for the amazon connect instance from the connect lookups endpoint.
 */
export const getPhoneNumbersAsync = async () => {
	try {
		let phoneNumbers = await axios.get(`${APIGateways.connectLookupsEndpoint}/phoneNumbers`, {
			headers: await getAuthHeader(),
		});

		return phoneNumbers.data.PhoneNumberSummaryList;
	} catch (error) {
		v2.error(`Error getting phone numbers`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_PHONE_NUMBERS_API_ERROR,
		});
		throw error;
	}
};
